const LOAD_DATA_JOB_POSITION_BY_INDUSTRY           = 'LOAD_DATA_JOB_POSITION_BY_INDUSTRY'
const LOAD_DATA_JOB_POSITION_BY_INDUSTRY_SUCCESS   = 'LOAD_DATA_JOB_POSITION_BY_INDUSTRY_SUCCESS'
const LOAD_DATA_JOB_POSITION_BY_INDUSTRY_FAILED    = 'LOAD_DATA_JOB_POSITION_BY_INDUSTRY_FAILED'
const UNMOUNT_DATA_JOB_POSITION_BY_INDUSTRY        = 'UNMOUNT_DATA_JOB_POSITION_BY_INDUSTRY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobPositionByIndustryReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB_POSITION_BY_INDUSTRY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_JOB_POSITION_BY_INDUSTRY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_JOB_POSITION_BY_INDUSTRY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_JOB_POSITION_BY_INDUSTRY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobPositionByIndustryReducer;